<template>
    <div style="width:100%;height:100%">
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-button type="primary" size="mini" @click="showitems">{{$t('getapi[438]')}}</el-button>
                    <el-button type="primary" size="mini" @click="remove">{{$t('getapi[437]')}}</el-button>
                    <el-button type="primary" size="mini" @click="download">{{$t('getapi[6111]')}}</el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[4410]')}}</el-button>
                    </el-upload>
                </div>
                <div style="width: 50%;text-align: right">
                    <el-button type="primary" size="mini" @click="check">{{$t('getapi[439]')}}</el-button>
                    <el-button type="primary" size="mini" @click="update">{{$t('getapi[440]')}}</el-button>
                    <!--<el-button type="primary" size="mini">关闭</el-button>-->
                </div>
            </div>
        </el-card>
        <el-row :gutter="5">
            <el-col :span="18">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span style="font-size: 14px;">{{$t('getapi[428]')}}</span>
                        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                    </div>
                    <el-checkbox v-model="SalePrice">{{$t('getapi[430]')}}</el-checkbox>
                    <el-checkbox v-model="PurOrder">{{$t('getapi[435]')}}</el-checkbox>
                    <el-checkbox v-model="ProcOrder">{{$t('getapi[433]')}}</el-checkbox>
                    <el-checkbox v-model="ProdOrder">{{$t('getapi[432]')}}</el-checkbox>
                    <el-checkbox v-model="SaleOrder">{{$t('getapi[431]')}}</el-checkbox>
                    <el-checkbox v-model="ProcPrice">{{$t('getapi[429]')}}</el-checkbox>
                    <el-checkbox v-model="PurPrice">{{$t('getapi[13088]')}}</el-checkbox>
                </el-card>
            </el-col>
            <!-- <el-col :span="8">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>执行参数设置</span>
                    </div>
                    <el-checkbox v-model="ProdGet">允许生成领料</el-checkbox>
                    <el-checkbox v-model="SaleOut">允许销售发货</el-checkbox>
                    <el-checkbox v-model="MakeProd">允许下达新工单</el-checkbox>
                </el-card>
            </el-col> -->
        </el-row>

        <div>
            <el-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    tab-click="selectInfo(0)"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    :cell-class-name="rowClass"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column> -->
                <el-table-column prop="state" :label="$t('getapi[114]')">
                    <template scope="scope">
                        <span>{{scope.row.state | lanchange}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="part_id" :label="$t('getapi[443]')"
                                 align="right"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                <el-table-column prop="s_bom" :label="$t('getapi[444]')">
                    <template scope="scope">
                        <span>{{scope.row.s_bom == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_routing" :label="$t('getapi[445]')">
                    <template scope="scope">
                        <span>{{scope.row.s_routing == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_purpart" :label="$t('getapi[446]')">
                    <template scope="scope">
                        <span>{{scope.row.s_purpart == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_salepart" :label="$t('getapi[447]')">
                    <template scope="scope">
                        <span>{{scope.row.s_salepart == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_stock" :label="$t('getapi[448]')">
                    <template scope="scope">
                        <span>{{scope.row.s_stock == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_purprice" :label="$t('getapi[449]')">
                    <template scope="scope">
                        <span>{{scope.row.s_purprice == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_saleprice" :label="$t('getapi[450]')">
                    <template scope="scope">
                        <span>{{scope.row.s_saleprice == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_procprice" :label="$t('getapi[451]')">
                    <template scope="scope">
                        <span>{{scope.row.s_procprice == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_PurOrder" :label="$t('getapi[101]')">
                    <template scope="scope">
                        <span>{{scope.row.s_PurOrder == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_SaleOrder" :label="$t('getapi[452]')">
                    <template scope="scope">
                        <span>{{scope.row.s_SaleOrder == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_ProcOrder" :label="$t('getapi[453]')">
                    <template scope="scope">
                        <span>{{scope.row.s_ProcOrder == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_SO" :label="$t('getapi[454]')">
                    <template scope="scope">
                        <span>{{scope.row.s_SO == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_SR" :label="$t('getapi[455]')">
                    <template scope="scope">
                        <span>{{scope.row.s_SR == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_PurPlan" :label="$t('getapi[97]')">
                    <template scope="scope">
                        <span>{{scope.row.s_PurPlan == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_PurRec" :label="$t('getapi[456]')">
                    <template scope="scope">
                        <span>{{scope.row.s_PurRec == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_PurRecIn" :label="$t('getapi[457]')">
                    <template scope="scope">
                        <span>{{scope.row.s_PurRecIn == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_PurRet" :label="$t('getapi[458]')">
                    <template scope="scope">
                        <span>{{scope.row.s_PurRet == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_ProdIn" :label="$t('getapi[459]')">
                    <template scope="scope">
                        <span>{{scope.row.s_ProdIn == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="s_ProdOut" :label="$t('getapi[460]')">
                    <template scope="scope">
                        <span>{{scope.row.s_ProdOut == true?$t('getapi[489]'):$t('getapi[490]')}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="Exec_No" :label="$t('getapi[463]')"
                                 align="right"></el-table-column>
            </el-table>
        </div>

        <!--<pickpartInvalid :isVisible="itevisible" @getitembom="getitembom" ref="input"></pickpartInvalid>-->
        <!-- 项目代号 -->
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Eng/Parts/ItemEnableGetPart'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'invalidsetting',
        data() {
            return {
                itevisible: false,
                dataSet: [],
                oldDataSet: [],
                ExecNo: '',
                selectData: [], // 选中集合
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 235, // 主表高度
                uploadurl: '',
                fileList: [],
                SalePrice: false,// 销售价表
                PurOrder: false,// 采购订单
                ProcOrder: false,// 外协订单
                ProdOrder: false,// 生产订单
                SaleOrder: false,// 销售订单
                ProcPrice: false,// 外协价表
                PurPrice: false,// 生产价表
                ProdGet: false,// 允许生成
                SaleOut: false,// 允许销售
                MakeProd: false,// 允许下达新工单
                scrollTop:0,
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Eng/Parts/ItemEnableImportUpFile?token=' + token;
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[60]"),this.$t("getapi[18]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            rowClass({ row, column, rowIndex, columnIndex }){
                if(columnIndex == 1 && row.state == '不可设') {
                    return 'red'
                }
            },
            //下载不可用设置模板
            download() {
                let param = {
                    url: '/Eng/Parts/ItemEnableTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            getitembom(data) {
                let that = this;
                if (data.length > 0) {
                    let arr = [];
                    let str = ""
                    let ids = ""
                    if (data.length > 0) {

                        for (let i = 0; i < data.length; i++) {
                            arr.push(data[i].exclusively_id);
                        }

                        for (let i = 0; i < arr.length; i++) {
                            str = str + arr[i] + ","
                        }
                        ids = str.substr(0, str.length - 1)
                        if (that.dataSet.length > 0) {
                            that.ExecNo = that.dataSet[0]['Exec_No'];
                        } else {
                            that.ExecNo = ''
                        }
                    }
                    let parm = {
                        Code: ids,
                        ExecNo: that.ExecNo
                    }
                    that.$http.urlpost('/Eng/Parts/GetPartItemEnable', parm, function (res) {
                        if (res.Success == 1) {
                            let data = res.DataContent
                            data = data.filter(item => {
                                return that.dataSet.every(item2 => {
                                    return item.Exclusively_ID != item2.part_id;
                                });
                            });
                            for (let i = 0; i < data.length; i++) {
                                that.dataSet = [...that.dataSet, {
                                    state: data[i].State,
                                    Exec_No: data[i].Exec_No,
                                    Module_Name: data[i].Module_Name,
                                    part_id: data[i].Exclusively_ID,
                                    part_code: data[i].part_code,
                                    part_version: data[i].part_version,
                                    part_name: data[i].part_name,
                                    s_bom: 0,
                                    s_routing: 0,
                                    s_purpart: 0,
                                    s_purprice: 0,
                                    s_salepart: 0,
                                    s_saleprice: 0,
                                    s_stock: 0,
                                    s_PurOrder: 0,
                                    s_SaleOrder: 0,
                                    s_SO: 0,
                                    s_SR: 0,
                                    s_PurPlan: 0,
                                    s_PurRec: 0,
                                    s_PurRecIn: 0,
                                    s_PurRet: 0,
                                    s_ProdIn: 0,
                                    s_ProdOut: 0,
                                    s_SaleOut: 0,
                                    s_SaleRet: 0,
                                    s_ProcOrder: 0,
                                    s_procprice: 0
                                }]
                            }
                            if (res.DataContent.length > 0) {
                                that.ExecNo = that.dataSet[0]['Exec_No'];
                            }
                        }
                    });
                }
            },
            handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
            },
            remove() {
                let that = this;
                let list = []
                let param = {
                    ExecNo: that.ExecNo,
                    List: []
                }
                for (let i = 0; i < that.selectData.length; i++) {
                    param.List = [...param.List, {
                        part_id: that.selectData[i].part_id,
                        part_code: that.selectData[i].part_code,
                        part_version: that.selectData[i].part_version
                    }]
                }
                let arr = that.dataSet.filter(item => {
                    return that.selectData.every(item2 => {
                        return item.part_id != item2.part_id
                    })
                })
                that.dataSet = arr;
                that.$http.urlpost('/Eng/Parts/DelPartItemEnable', param, function (res) {
                    if (res.Success == 1) {
                        that.selectData = []
                        console.log(1)
                    }
                });
            },
            handleChange(file, fileList) {
                let that = this;
                /*if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    } else {
                        console.log(file.response.DataContent)
                        that.dataSet = file.response.DataContent;
                    }
                }*/
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent
                    data = data.filter(item => {
                        return that.dataSet.every(item2 => {
                            return item.Exclusively_ID != item2.part_id;
                        });
                    });
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            state: data[i].state,
                            Exec_No: data[i].Exec_No,
                            Module_Name: data[i].Module_Name,
                            part_id: data[i].Exclusively_ID,
                            part_code: data[i].part_code,
                            part_version: data[i].Part_version,
                            part_name: data[i].Part_name,
                            s_bom: 0,
                            s_routing: 0,
                            s_purpart: 0,
                            s_purprice: 0,
                            s_salepart: 0,
                            s_saleprice: 0,
                            s_stock: 0,
                            s_PurOrder: 0,
                            s_SaleOrder: 0,
                            s_SO: 0,
                            s_SR: 0,
                            s_PurPlan: 0,
                            s_PurRec: 0,
                            s_PurRecIn: 0,
                            s_PurRet: 0,
                            s_ProdIn: 0,
                            s_ProdOut: 0,
                            s_SaleOut: 0,
                            s_SaleRet: 0,
                            s_ProcOrder: 0,
                            s_procprice: 0
                        }];
                    }
                    that.ExecNo = that.dataSet[0]['Exec_No'];
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':'+ err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            check() {
                let that = this
                let parm = {
                    ExecNo: that.ExecNo,
                    SalePrice: that.SalePrice,
                    PurOrder: that.PurOrder,
                    ProcOrder: that.ProcOrder,
                    ProdOrder: that.ProdOrder,
                    SaleOrder: that.SaleOrder,
                    ProcPrice: that.ProcPrice,
                    PurPrice: that.PurPrice,
                    ProdGet: that.ProdGet,
                    SaleOut: that.SaleOut,
                    MakeProd: that.MakeProd
                }
                that.$http.urlpost('/Eng/Parts/ItemEnableCheck', parm, function (res) {
                    if (res.Success == 1) {
                        console.log(111)
                        that.dataSet = res.DataContent
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        console.log(JSON.stringify(that.dataSet))
                    }
                });
            },
            update() {
                let that = this
                for (let i = 0; i < that.dataSet.length; i++) {
                    that.dataSet[i].s_bom = that.dataSet[i].s_bom == true ? 1 : 0,
                        that.dataSet[i].s_routing = that.dataSet[i].s_routing == true ? 1 : 0,
                        that.dataSet[i].s_purpart = that.dataSet[i].s_purpart == true ? 1 : 0,
                        that.dataSet[i].s_purprice = that.dataSet[i].s_purprice == true ? 1 : 0,
                        that.dataSet[i].s_salepart = that.dataSet[i].s_salepart == true ? 1 : 0,
                        that.dataSet[i].s_saleprice = that.dataSet[i].s_saleprice == true ? 1 : 0,
                        that.dataSet[i].s_stock = that.dataSet[i].s_stock == true ? 1 : 0,
                        that.dataSet[i].s_PurOrder = that.dataSet[i].s_PurOrder == true ? 1 : 0,
                        that.dataSet[i].s_SaleOrder = that.dataSet[i].s_SaleOrder == true ? 1 : 0,
                        that.dataSet[i].s_SO = that.dataSet[i].s_SO == true ? 1 : 0,
                        that.dataSet[i].s_SR = that.dataSet[i].s_SR == true ? 1 : 0,
                        that.dataSet[i].s_PurPlan = that.dataSet[i].s_PurPlan == true ? 1 : 0,
                        that.dataSet[i].s_PurRec = that.dataSet[i].s_PurRec == true ? 1 : 0,
                        that.dataSet[i].s_PurRecIn = that.dataSet[i].s_PurRecIn == true ? 1 : 0,
                        that.dataSet[i].s_PurRet = that.dataSet[i].s_PurRet == true ? 1 : 0,
                        that.dataSet[i].s_ProdIn = that.dataSet[i].s_ProdIn == true ? 1 : 0,
                        that.dataSet[i].s_ProdOut = that.dataSet[i].s_ProdOut == true ? 1 : 0,
                        that.dataSet[i].s_SaleOut = that.dataSet[i].s_SaleOut == true ? 1 : 0,
                        that.dataSet[i].s_SaleRet = that.dataSet[i].s_SaleRet == true ? 1 : 0,
                        that.dataSet[i].s_ProcOrder = that.dataSet[i].s_ProcOrder == true ? 1 : 0,
                        that.dataSet[i].s_procprice = that.dataSet[i].s_procprice == true ? 1 : 0
                }
                let parm = {
                    partItemEnable: that.dataSet,
                    itemEnableFlag: {
                        ExecNo: that.ExecNo,
                        SalePrice: that.SalePrice,
                        PurOrder: that.PurOrder,
                        ProcOrder: that.ProcOrder,
                        ProdOrder: that.ProdOrder,
                        SaleOrder: that.SaleOrder,
                        ProcPrice: that.ProcPrice,
                        PurPrice: that.PurPrice,
                        ProdGet: that.ProdGet,
                        SaleOut: that.SaleOut,
                        MakeProd: that.MakeProd
                    }
                }
                that.$http.urlpost('/Eng/Parts/ItemEnableSave', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }

    .el-card__header {
        padding: 10px 10px;
    }

    /deep/ .red {
        color: red;
    }
</style>
